import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface UnsavedChangesDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirmLeave: () => void;
  title?: string;
  message?: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

/**
 * Reusable dialog component for warning users about unsaved changes
 * when they try to leave the current tab/context.
 */
const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onClose,
  onConfirmLeave,
  title = 'Thông tin chưa được lưu',
  message = 'Bạn có thay đổi chưa được lưu. Bạn có muốn lưu các thay đổi trước khi chuyển sang tab khác không?',
  cancelLabel = 'Hủy',
  confirmLabel = 'Rời khỏi mà không lưu',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="unsaved-changes-dialog-title"
    >
      <DialogTitle id="unsaved-changes-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {cancelLabel}
        </Button>
        <Button onClick={onConfirmLeave} color="error" variant="contained">
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;














